import { request } from '@/utils/request/request';

export function contrastiveAnalysis(data) {
  return request({
    url: 'api/tongji/v1/ContrastiveAnalysis',
    method: 'GET',
    params: data,
  });
}
export function peakValleyAnalysis(data) {
  return request({
    url: 'api/tongji/v1/PeakValleyAnalysis',
    method: 'GET',
    params: data,
  });
}
export function loadAnalysis(data) {
  return request({
    url: 'api/tongji/v1/LoadAnalysis',
    method: 'GET',
    params: data,
  });
}

export function eleQuery(data) {
  return request({
    url: 'api/tongji/v1/GetYongNengChaXunList',
    method: 'GET',
    params: data,
  });
}
